import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=0a1c8e1f&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1c8e1f')) {
      api.createRecord('0a1c8e1f', component.options)
    } else {
      api.reload('0a1c8e1f', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=0a1c8e1f&", function () {
      api.rerender('0a1c8e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aOg5mz6pGKOg/JS/comp/IncreaseNumber.vue"
export default component.exports